module.exports = __webpack_public_path__ + "static/media/protheus.b999110e.png";